export enum ShimmerRouteKey {
  Storefront = 'storefront',
  Landing = 'landing',
   MyAha="myaha",
}

export type ShimmerKey = keyof typeof ShimmerRouteKey;

export function isValidShimmerKey(key: string): key is ShimmerKey {
  return Object.values(ShimmerRouteKey).includes(key as ShimmerRouteKey);
}

export default ShimmerRouteKey;
